/**
 * @returns {import("swr/mutation").SWRMutationResponse}
 */
export function getUseSwrMutationReturn(ret) {
	return {
		trigger: ret.trigger,
		isMutating: ret.isMutating,
		data: ret.data,
		error: ret.error,
		reset: ret.reset,
	};
}
